import React from 'react'
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left'
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right'
import Pagination from 'react-js-pagination'

const Paginator = ({
  activePage,
  perPage,
  totalCount,
  onChange
}) => {

  return (
    <Pagination
      activePage={activePage}
      activeClass="active"
      firstPageText='first'
      lastPageText='last'
      prevPageText={<ChevronLeft />}
      nextPageText={<ChevronRight />}
      itemsCountPerPage={perPage} 
      totalItemsCount={totalCount} 
      onChange={onChange}
    />
  )
}

export default Paginator



// WEBPACK FOOTER //
// ./src/components/Outreach/Pagination.js